<template>

  <div class="padded">

    <el-alert show-icon type="info1" title="Please Note" description="Searching for 'description' is Case Senstive" />

    <data-table
      title="Sytem Audit Logs"
      title-heading="h5"

      url="/view/logs"
      :fields="fields"
      ref="auditLogs"
      sort-field="updated_at|desc"
      search-placeholder="Category, Description, User..."
      table-ref="auditLogsDataTable">

    </data-table>
  </div>

</template>


<script>

import DateMixins from '@/mixins/DateMixins'

export default {

  mixins: [DateMixins],

  data () {
    return {

      fields: [
        {
          title: 'Category',
          name: 'category',
          sortField: 'category',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          title: 'Description',
          name: 'description',
          sortField: 'description'
        },
        {
          title: 'User',
          name: 'updated_by',
          sortField: 'updated_by'
        },
        {
          title: 'Updated',
          name: 'updated_at',
          sortField: 'updated_at',
          callback: this.formatDateTime
        },
        {
          title: 'Created',
          name: 'created_at',
          sortField: 'created_at',
          callback: this.formatDate
        }
      ]
    }
  }
}
</script>
